import { useTranslation } from "react-i18next";
import NavigateBack from "../../components/navigateBack";
import React, { useEffect, useState } from "react";
import { ReactComponent as TestsPxLoading } from "../../img/medicaltest_loading.svg";
import createPersistedState from "use-persisted-state";

const dummyPrescription = {
  status: {
    success: true,
    code: 200,
    message: null,
  },
  prescription: {
    id: 1,
    date: "2023-01-07",
    bodyScans: ["X-ray - Lower back", "MRI", "CT-Scan", "Sonography"],
    pathologies: ["FBS Blood test", "CBC Blood test"],
  },
  history: [],
};

const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");

/*
 * TODO:
 * Format date as per UI/UX
 * Implement Share CTA and what do about the other one?
 * Avoid code duplication, since data fetch is very similar to prescription page
 * Button should leverage translations. Applies to px pages as well
 */
function MyTestsPrescriptionsPage() {
  const { t } = useTranslation();
  const [token, _] = useTokenState();
  const [pid, __] = usePIDState();
  const [isLoading, setIsLoading] = useState(false);
  const [px, setPx] = useState(undefined);
  const getUrl = (pId, docId) =>
    `/api/v1/users/prescriptions/${pId}?doctorId=${docId}`;

  const fetchPx = (pId, docId, token) => {
    setIsLoading(true);
    fetch(getUrl(pId, docId, token), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"]) {
          // TODO: Add relevant validation here
          setPx(responseData["prescription"]);
        }
        // TODO: Else report error
      })
      .catch((e) => {
        console.log(e.message); //TODO: Report error
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (pid && token) {
      fetchPx(pid, "DR000001", token); // TODO: Fetch docId from localStorage
    } // TODO: Else report error
  }, [pid, token]);

  const loadingView = () => (
    <div
      id="loading_content"
      className="loading_content text-center py-3"
      style={{ marginTop: "90px" }}
    >
      <p className="desc" style={{ textAlign: "center", margin: "auto" }}>
        {t("px.fetchingLatestPxMsg1")}
      </p>
      <p
        className="desc"
        style={{ textAlign: "center", margin: "auto", width: "60%" }}
      >
        {t("px.fetchingTestsPxMsg2")}
      </p>
      <div className="thumbnail" style={{ marginTop: "5em" }}>
        <TestsPxLoading className="img-fluid" />
      </div>
    </div>
  );

  const testsSectionView = (sectionName, tests) => (
    <>
      <h3 className="heading_title">{sectionName}</h3>
      <ul className="list-unstyled list_test">
        {tests.map((test, index) => (
          <li key={index}>
            <span className="txt_details">
              {(index + 1).toString() + " . " + test}
            </span>
          </li>
        ))}
      </ul>
      <div className="btn_block d-flex">
        <button className="btn btn_outline">Share</button>
        <button className="btn btn_primary">Check Price and Order</button>
      </div>
    </>
  );

  const testsView = (px) => {
    return px ? (
      <div id="test_content" className="animate-bottom">
        <div className="content_mt">
          <span className="txt_date d-flex justify-content-end">{px.date}</span>
          <div className="row">
            <div className="col-12 gridcol">
              <div className="box_mt">
                {px.bodyScans?.length !== 0 &&
                  testsSectionView(t("px.bodyScanHeader"), px.bodyScans)}
              </div>
            </div>
            <div className="col-12 gridcol">
              <div className="box_mt">
                {px.pathologies?.length !== 0 &&
                  testsSectionView(t("px.pathologyHeader"), px.pathologies)}
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <>Failed to load recommended test</>
    );
  };

  return (
    <>
      <NavigateBack title={t("px.testsTitle")} />
      <div className="body_content py-3">
        <div id="lastestpx" className="inner_body">
          {isLoading ? loadingView() : testsView(px)}
        </div>
      </div>
    </>
  );
}

export default MyTestsPrescriptionsPage;
